var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block import-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "postForm",
    staticClass: "demo-form",
    attrs: {
      model: _vm.postForm,
      "status-icon": "",
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-button", {
    attrs: {
      size: "mini",
      type: "warning",
      disabled: _vm.processingMoqs
    },
    on: {
      click: function ($event) {
        _vm.showWarningDialog = true;
      }
    }
  }, [_vm._v(" Click to Upload ")]), _c("div", {
    staticClass: "el-upload__tip",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v(" Only Excel files (.xlsx, .xls) are allowed ")]), _c("el-upload", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: false,
      expression: "false"
    }],
    ref: "uploadRef",
    staticClass: "upload-demo",
    attrs: {
      action: "",
      "on-change": _vm.handleChange,
      "on-remove": _vm.handleRemove,
      "on-exceed": _vm.handleExceed,
      "auto-upload": false,
      limit: 1,
      accept: ".xlsx,.xls"
    },
    model: {
      value: _vm.postForm.file,
      callback: function ($$v) {
        _vm.$set(_vm.postForm, "file", $$v);
      },
      expression: "postForm.file"
    }
  })], 1), _vm.showPreview ? _c("div", {
    staticClass: "preview-section"
  }, [_c("h3", [_vm._v("Data Preview (" + _vm._s(_vm.excelData.length) + " rows)")]), _c("el-table", {
    staticStyle: {
      width: "100%",
      "margin-top": "20px"
    },
    attrs: {
      data: _vm.excelData,
      border: "",
      "max-height": "400"
    }
  }, [_c("el-table-column", {
    attrs: {
      prop: "moqId",
      label: "MOQ ID",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "dealersRoleId",
      label: "Dealers Role ID",
      width: "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "dealersRole",
      label: "Dealers Role",
      width: "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "rangeId",
      label: "Range ID",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "rangeName",
      label: "Range Name",
      width: "140"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productId",
      label: "Product ID",
      width: "120"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productName",
      label: "Product Name",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "productsVariationId",
      label: "Variation ID",
      width: "130"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "variationName",
      label: "Variation Name",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "minimumQuantity",
      label: "Minimum Quantity (Optional)",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "minimumCartonQuantity",
      label: "Minimum Carton Quantity",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "discount",
      label: "Discount",
      width: "130"
    }
  })], 1), _c("div", {
    staticStyle: {
      "margin-top": "20px",
      "text-align": "center"
    }
  }, [_c("el-button", {
    attrs: {
      type: "primary",
      loading: _vm.processingMoqs
    },
    on: {
      click: _vm.handleImport
    }
  }, [_vm._v(" Import Data ")]), _c("el-button", {
    attrs: {
      disabled: _vm.processingMoqs
    },
    on: {
      click: _vm.cancelImport
    }
  }, [_vm._v(" Cancel ")])], 1)], 1) : _vm._e()], 1), _c("el-dialog", {
    attrs: {
      title: "Important Instructions",
      visible: _vm.showWarningDialog,
      width: "600px",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.showWarningDialog = $event;
      }
    }
  }, [_c("div", {
    staticClass: "warning-content"
  }, [_c("el-alert", {
    attrs: {
      title: "Please read carefully before uploading",
      type: "warning",
      closable: false,
      "show-icon": ""
    }
  }), _c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("p", [_c("strong", [_vm._v("1.")]), _vm._v(" Upload only when you have created a valid MOQ or have an existing MOQ.")]), _c("p", [_c("strong", [_vm._v("2.")]), _vm._v(" Excel must have the "), _c("code", [_vm._v("moqId")]), _vm._v(" column from "), _c("code", [_vm._v("1")]), _vm._v(".")]), _c("p", [_c("strong", [_vm._v("3.")]), _vm._v(" The Excel should strictly follow the column patterns as follows: ")]), _c("ul", {
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c("li", [_vm._v("moqId")]), _c("li", [_vm._v("dealersRoleId")]), _c("li", [_vm._v("dealersRole")]), _c("li", [_vm._v("rangeId")]), _c("li", [_vm._v("rangeName")]), _c("li", [_vm._v("productId")]), _c("li", [_vm._v("productName")]), _c("li", [_vm._v("productsVariationId")]), _c("li", [_vm._v("variationName")]), _c("li", [_vm._v("minimumQuantity "), _c("em", [_vm._v("(optional)")])]), _c("li", [_vm._v("minimumCartonQuantity")]), _c("li", [_vm._v("discount")])])])], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    on: {
      click: _vm.cancelWarning
    }
  }, [_vm._v("Cancel")]), _c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.proceedWithUpload
    }
  }, [_vm._v(" I Understand, Proceed ")])], 1)]), _c("el-dialog", {
    attrs: {
      visible: _vm.processingMoqs,
      width: "400px",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false,
      center: ""
    },
    on: {
      "update:visible": function ($event) {
        _vm.processingMoqs = $event;
      }
    }
  }, [_c("div", {
    staticStyle: {
      "text-align": "center",
      padding: "20px"
    }
  }, [_c("i", {
    staticClass: "el-icon-loading",
    staticStyle: {
      "font-size": "48px",
      color: "#409eff"
    }
  }), _c("p", {
    staticStyle: {
      "margin-top": "20px",
      "font-size": "16px"
    }
  }, [_vm._v(" Importing data, please wait... ")]), _c("p", {
    staticStyle: {
      color: "#909399",
      "font-size": "14px"
    }
  }, [_vm._v(" Do not close this window ")])])])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };